import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "button.changeCustomerStatus.label",
    defaultMessage: "Change customer status",
    description: "change status button label",
  },
});
